import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Grid,
} from "@mui/material";
import MDButton from "components/MDButton";
const ModalSeleccionMetodoPago = ({ open, onClose, onSelect }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Seleccionar método de pago</DialogTitle>

      <DialogContent>
        <Typography>
          No seleccionaste un método de pago. Elige una opción para continuar.
        </Typography>
      </DialogContent>

      <DialogActions sx={{ p: 2 }}>
        <Grid container spacing={2}>
            <Grid item xs={4}>
                <MDButton
                fullWidth
                color="success"
                variant="gradient"
                onClick={() => {
                    onSelect("EFECTIVO");
                    onClose();
                }}
                >
                Efectivo
                </MDButton>
            </Grid>

            <Grid item xs={4}>
                <MDButton
                fullWidth
                color="info"
                variant="gradient"
                onClick={() => {
                    onSelect("QR");
                    onClose();
                }}
                >
                QR
                </MDButton>
            </Grid>

            <Grid item xs={4}>
                <MDButton
                fullWidth
                color="warning"
                variant="gradient"
                onClick={() => {
                    onSelect("MIXTO");
                    onClose();
                }}
                >
                Mixto
                </MDButton>
            </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};

export default ModalSeleccionMetodoPago;